<script setup lang="ts">
    import { inject, computed, ref } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { FeatureService } from '@shared/directives/Feature.service';

    const props = defineProps<{
        feature: string;
        hideWhenLocked?: boolean;
        showUpgradeAlert?: boolean;
        infoTitle?: string;
        infoText?: string;
    }>();

    const injectorAccess = inject(injectorAccessInjectionKey);
    const featureService = injectorAccess?.injector.get(FeatureService);
    const backOfficeOverride = ref(false);
    const showInfoText = ref(false);
    const isBackOffice = computed(() => featureService?.hasFeature('BackOffice') ?? false);
    const isLocked = computed(() => !backOfficeOverride.value && (featureService ? !featureService.hasFeature(props.feature) : false));
</script>

<template>
    <template v-if="!isLocked">
        <slot />
    </template>
    <template v-else-if="!hideWhenLocked">
        <div v-if="showUpgradeAlert" class="alert alert-info banner-upgrade">
            <p>
                <span class="feature-mark">{{ $Resources.FeatureLabel }}</span>
                {{ ' ' }}
                <strong v-if="infoTitle">{{ infoTitle }}</strong>
                {{ ' ' }}
                {{ $Resources.FeatureLockedText }}
                {{ ' ' }}
                <a :href="`/Account/Upgrade?feature=${feature}`">{{ $Resources.UpgradeToUseFeatureText }}</a>
                {{ ' ' }}
                <template v-if="infoText">
                    {{ $Resources.OrLabel }}
                    <a class="text-lowercase" href="javascript:void(0)" role="button" @click="showInfoText = true">{{ $Resources.ReadMoreBtn }}</a>
                </template>
            </p>
            <p v-if="infoText" v-show="showInfoText">{{ infoText }}</p>
            <button v-if="isBackOffice" type="button" class="btn btn-default btn-xs m-xs-t m-xs-b" @click="backOfficeOverride = true">
                Show feature override
            </button>
        </div>
        <slot v-else name="locked" />
    </template>
</template>
